import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface BearState {
  bearer: string;
  setBearer: (bearer: string) => void;
}

export const useBearer = create<BearState>()(
  persist(
    (set) => ({
      bearer: '',
      setBearer: (bearer) => set(() => ({ bearer })),
    }),
    { name: 'bearer', storage: createJSONStorage(() => localStorage) },
  ),
);
